import { Navigate } from "react-router-dom";
import { useUserRole, AppRole } from "@/hooks/useUserRole";
import { useLanguage } from "@/contexts/LanguageContext";
import { Clock } from "lucide-react";

interface RoleProtectedRouteProps {
  allowedRoles: AppRole[];
  children: React.ReactNode;
}

export const RoleProtectedRoute = ({ allowedRoles, children }: RoleProtectedRouteProps) => {
  const { role, status, loading } = useUserRole();
  const { isRTL } = useLanguage();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  // IB pending approval: show content with a banner instead of blocking
  return (
    <>
      {role === "ib" && status === "pending" && (
        <div className="mx-6 mt-4 flex items-center gap-3 rounded-lg border border-warning/30 bg-warning/5 px-4 py-3">
          <Clock className="w-5 h-5 text-warning shrink-0" />
          <p className="text-sm text-warning">
            {isRTL
              ? "حساب IB شما در انتظار تأیید ادمین است. برخی اقدامات ممکن است محدود باشند."
              : "Your IB account is pending admin approval. Some actions may be restricted."}
          </p>
        </div>
      )}
      {children}
    </>
  );
};
